import Cookies from "js-cookie";
import { useHistory, useLocation } from "react-router-dom";
import { getPrimaryDomain } from "@/react/helpers/urlHelpers/currentDomain";

interface UseSourceTrackingReturn {
  clearSource: () => void;
  navigateWithSource: (path: string) => void;
  source: string | undefined;
}

const ONBOARDING_SOURCE_KEY = "onboarding_source";

export const useSourceTracking = (): UseSourceTrackingReturn => {
  const location = useLocation();
  const history = useHistory();

  const urlParams = new URLSearchParams(location.search);
  const urlSource = urlParams.get("source");

  const cookieOptions = {
    expires: 1,
    path: "/",
    domain: "." + getPrimaryDomain(window.location.hostname),
  };

  if (urlSource) {
    Cookies.set(ONBOARDING_SOURCE_KEY, urlSource, cookieOptions);
  }

  const source = urlSource || Cookies.get(ONBOARDING_SOURCE_KEY);

  const navigateWithSource = (path: string): void => {
    history.push(path);
  };

  const clearSource = (): void => {
    Cookies.remove(ONBOARDING_SOURCE_KEY, cookieOptions);
  };

  return {
    source,
    navigateWithSource,
    clearSource,
  };
};
